import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import newlogo from "./../../assets/Images/sign-in-logo.svg";

function ForgotPassword() {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('key'); // Assuming backend sends token as 'key' in the URL

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

    const handleResetPassword = async (e) => {
        e.preventDefault();

        if (!passwordRegex.test(password)) {
            setMessage('Password must be at least 8 characters long, include one uppercase letter, one number, and one special character.');
            return;
        }

        if (password !== confirmPassword) {
            setMessage('Passwords do not match.');
            return;
        }

        setLoading(true);
        setMessage('');

        try {
            const response = await axios.patch(
                `${baseUrl}/auth/forgot-password-reset`,
                { password: password },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token,
                    },
                }
            );

            setMessage(response.data.message || 'Password reset successful.');
            setTimeout(() => navigate('/login'), 3000); // Redirect after 3 seconds
        } catch (error) {
            setMessage(error.response?.data?.message || 'Failed to reset password.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-wrapper">
            <div className="login-overlay">
                <div className="container-fluid h-100 d-flex justify-content-around align-items-center flex-wrap trans-bg">
                    <div className="login-form-box bg-white p-4 rounded shadow" style={{ maxWidth: "400px", width: "100%" }}>
                        <h5 className="text-center my-2 fw-600">Setup New Password</h5>
                        <h6 className="mb-4 text-center fnt13">Have you already reset the password? <Link to="/login" className="decoration-none">Sign in</Link></h6>
                        {message && <p style={{ color: message.includes('success') ? 'green' : 'red' }}>{message}</p>}
                        <form onSubmit={handleResetPassword}>
                            <div className="mb-3 text-dark">
                                <label htmlFor="password" className="form-label fnt12">Password</label>
                                <input
                                    type="text"
                                    id="password"
                                    placeholder="***********"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                {!passwordRegex.test(password) && password && (
                                    <p className="text-danger small">
                                        Password must be at least 8 characters long, include one uppercase letter, one number, and one special character.
                                    </p>
                                )}
                            </div>
                            <div className="mb-3 text-dark">
                                <label htmlFor="confirmPassword" className="form-label fnt12">Confirm Password</label>
                                <input
                                    type="text"
                                    id="confirmPassword"
                                    placeholder="***********"
                                    className="form-control"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                                {confirmPassword && confirmPassword !== password && (
                                    <p className="text-danger small">Passwords do not match.</p>
                                )}
                            </div>
                            <button type="submit" className="btn btn-primary w-100" disabled={loading || !token || !passwordRegex.test(password) || password !== confirmPassword}>
                                {loading ? 'Resetting...' : 'Reset Password'}
                            </button>
                        </form>
                    </div>
                    <div className="text-center text-white mt-4 mt-lg-0 ms-lg-5">
                        <img src={newlogo} alt="Cold Core Logo" className="img-fluid" style={{ maxWidth: "22vw" }} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;